import styled from "styled-components";

export const CardContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: row;
    z-index: 0;
`;